import { render, staticRenderFns } from "./ccpit.vue?vue&type=template&id=a3bbfd28&scoped=true&"
import script from "./ccpit.vue?vue&type=script&lang=js&"
export * from "./ccpit.vue?vue&type=script&lang=js&"
import style0 from "./ccpit.vue?vue&type=style&index=0&id=a3bbfd28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bbfd28",
  null
  
)

export default component.exports